import { TYPES } from "./user.type";

const initState = {
  users: null,
  user: null,
};

const userReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_USERS_SUCCESS:
      return {
        ...state,
        users: payload,
      };
    case TYPES.SELECT_USER_SUCCESS:
      return {
        ...state,
        user: payload,
      };

    default:
      return state;
  }
};

export default userReducer;
